import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    box: {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.subtitle1.fontSize,
        justifyContent: "left",
        paddingRight: "20px 16px",
        paddingTop: "10px",
        width: "calc(100% - 124px)",
    },
    boxQuestion: {
        background: theme.palette.primary.main,
        borderRadius: "0px",
        padding: "13px 19px",
        textAlign: "left",
        width: "124px",
    },
    confirmButton: {
        borderRadius: "12px",
        fontSize: "16px",
        padding: "10px",
        textTransform: "none",
    },
    container: {
        padding: " 0px 22.5px 22.5px 22.5px ",
    },
    datePicker: {
        "& label": {
            display: "flex",
        },
        paddingTop: "5px",
    },
    expeditionDateDropdown: {
        position: "absolute",
        right: -5,
    },
    expeditionDateLabel: {
        paddingTop: "2px",
    },
    expeditionDateLabelIcon: {
        fontSize: "20px",
        paddingRight: "5px",
    },
    expeditionDateMargin: {
        marginBottom: "5px",
    },
    inputsMargin: {
        marginBottom: "10px",
    },
    methodSelection: { backgroundColor: theme.palette.secondary.main },
    otherPaymentMethod: {
        "&:hover": {
            cursor: "pointer",
        },
        fontFamily: theme.typography.fontFamily,
        padding: "10px",
    },
    placeholderInput: {
        alignContent: "center",
        textAlign: "center",
    },
    returnButton: {
        fontWeight: 100,
        textTransform: "none",
    },
    root: {
        alignContent: "center",
        textAlign: "center",
    },
    subtitle: {
        color: "#6D7781",
        fontWeight: "lighter",
        padding: "25px",
    },
    title: {
        fontWeight: 400,
        paddingBottom: "1px",
    },
}); });
